import React, { Component } from 'react'

export default class Categories extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categories: [
                {
                    key: 'all',
                    name: 'Все'
                },
                {
                    key: 'chairs',
                    name: 'Кресла'
                },
                {
                    key: 'tables',
                    name: 'Столы'
                },
                {
                    key: 'sofas',
                    name: 'Диваны'
                },
            ]
        }
    }
    render() {
        return (
            <div className='categories'>
                {
                    this.state.categories.map(el => (
                        <div key={el.key} onClick={() => this.props.chooseCategory(el.key)}>{el.name}</div>
                    ))}
            </div>
        )
    }
}
